// import { GetListDomesticBank } from "@/dto/transfer/response/TransferInfo";
import { api } from "api/api";
import { ApiResponse } from "api/api.d";
import { GetMoneySourceResponse } from "dto/bank/response/BankInfo.d";

const BASE_URL = "/customer-service/rest/web/request";
export const bankAPI = api.injectEndpoints({
  endpoints: (builder) => ({
    // getListDomesticBank: builder.query<ApiResponse<GetListDomesticBank>, void>({
    //   query: () => ({
    //     url: BASE_URL,
    //     method: "POST",
    //     functionName: "getDomesticBank",
    //   }),
    // }),
    getMoneySource: builder.query<ApiResponse<GetMoneySourceResponse>, void>({
      query: () => ({
        url: BASE_URL,
        categoryCode: "CORP_TRANS_TRANSFER_TO_ACCOUNT",
        method: "POST",
        functionName: "getMoneySource",
      }),
    }),
  }),
});

export const {
  useGetMoneySourceQuery,
  useLazyGetMoneySourceQuery,
  // useGetListDomesticBankQuery,
} = bankAPI;
